
<div class="fx-row-start-center">
    <gea-mes-datepicker
    class="dateRangeBut"
    matTooltip="Select Date" 
    (onDateSelect)="onDateSelection($event)" 
    (onDateInit)="onDateSelection($event)"
    singleDate="false" 
    showLabel="true"
    showCurrentShift="false"
    defaultRange="Today"
    showRangeLabel="true"
    autoApply="true"
    [index]=DatePickerIndex>
    </gea-mes-datepicker>
    <div style="min-width: 144px">
      <button mat-button [disabled]="disableRawgDataView" color="primary" (click)="openTableView()">Raw Data</button>
    </div>
</div>
<div *ngIf="hasData; else noDataTpl">
  <div
    echarts
    [options]="chartOptions"
    class="planned-downtime-chart"
    (chartInit)="onChartInit($event)">
  </div>
</div>
<ng-template #noDataTpl>
  <div class="no-data-found">No data to display</div>
</ng-template>
